import React, { useState, useEffect } from "react";
import "../Slider2/Slider2.css";
import Icard from "../Icard/Icard";

const Slider2 = () => {
  const images = [
    { src: "sl1.webp", alt: "Slide 1" },
    { src: "sl2.webp", alt: "Slide 2" },
    { src: "sl3.webp", alt: "Slide 3" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isIcardOpen, setIsIcardOpen] = useState(false);
  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1,
      );
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const openIcard = () => {
    setIsIcardOpen(true);
  };

  const closeIcard = () => {
    setIsIcardOpen(false);
  };

  return (
    <div className="slider2-container">
      {isIcardOpen && <Icard onClose={closeIcard} />}
      <div className="slider2-overlay-card">
        <div className="div-card">
          <h2 className="div-card-title1">PAN OASIS</h2>
          <p className="div-card-title">SECTOR 70</p>
          <p className="div-card-location">Central Noida</p>

          <p className="div-card-sizes">2100+ & 2400+ for 3 BHK + Servant</p>
          <div className="div-card-pricing">
            <p className="launch-price">
              Expected price: ₹13,500–14,000 per sq ft + Other Charges
            </p>
          </div>
          <div className="div-card-eoi">
            <p className="eoi-text">
              First Come First Serve Basis and limited offer exclusivity
            </p>
          </div>
          <div className="div-card-limited-offer">
            <p className="limited-offer-text">
              Limited offer only for chosen one
            </p>
          </div>
          <div className="div-card-context">
            <p className="context-text">
              PRE-LAUNCH OF THE YEAR in CENTRAL NOIDA
            </p>
            <p className="context-subtext">
              Ultra Luxury residential society in the heart of Noida
            </p>
          </div>
          <button className="div-card-enquiry" onClick={openIcard}>
            Enquire Now
          </button>
        </div>
      </div>

      <div
        className="slider2-wrapper"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((image, index) => (
          <div key={index} className="slider2-slide">
            <img src={image.src} alt={image.alt} className="slider2-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slider2;
